module.exports = __webpack_public_path__ + "static/media/Rotessa_logo_full_black.2cb33ad8.png";